export default function download(filename, text) {
  const content = new Blob([text], { type: 'text/csv'});
  const element = document.createElement('a');
  element.setAttribute('href', window.URL.createObjectURL(content));
  element.setAttribute('download', filename);
  element.style.display = 'none';
  document.body.appendChild(element);
  setTimeout(() => { 
    element.click();
  }, 50);

  document.body.removeChild(element);
}